document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const header = event.target.closest('.dama-header');
  if (!header) return;
  const openMenus = [...header.querySelectorAll('.dama-desktop-nav details[open]')];
  if (!openMenus.length) return;
  event.preventDefault();
  const summary = openMenus[0].querySelector('summary');
  openMenus.reverse().forEach((menu) => { menu.open = false; });
  summary?.focus();
});

// Keep the overlay readable once the customer scrolls beyond the hero's top.
const updateDamaHeader = () => {
  document.querySelectorAll('.dama-header').forEach(header => {
    header.classList.toggle('dama-scrolled', window.scrollY > 24);
  });
};
window.addEventListener('scroll', updateDamaHeader, { passive: true });
document.addEventListener('shopify:section:load', updateDamaHeader);
updateDamaHeader();
